/* global JQuery */
import { Badge2, BadgeType2, UtilColor, Widget2 } from 'bambooo';
import { UtilSpeciesContextMenu } from '../Utils/UtilSpeciesContextMenu';
export class SpeciesDisplay extends Widget2 {
    constructor(element, sighting, speciesList, onProfile) {
        var _a, _b, _c, _d;
        super({ element: jQuery('<span/>') });
        /**
         * turtles
         * @protected
         */
        this._turtles = [
            'Caretta caretta',
            'Dermochelys coriacea',
            'Chelonia mydas',
            'Eretmochelys imbricata',
            'Unknown sea turtle',
            'Eretmochelys imbricata - Hawksbill sea turtle',
            'Chelonia mydas - Green sea turtle',
            'Dermochelys coriacea - Leatherback sea turtle',
            'Caretta caretta - Loggerhead sea turtle'
        ];
        let specieName = '';
        /*
         * `undefined` → Badge2 falls back to its visible Bootstrap 5
         * `text-bg-info` class. A defined colour sets the badge background
         * directly. Must NOT default to an empty string: Badge2 treats an empty
         * string as a (defined) colour, so it adds neither the type class nor a
         * background — leaving a bare `.badge` that renders white-on-transparent
         * (i.e. an invisible, "empty" map popover). This is exactly what broke
         * sightings whose species group has no colour set.
         */
        let specieColor;
        const specie = speciesList.get(sighting.species_id);
        if (specie) {
            specieName = specie.name.split(',')[0];
            if ((_a = specie.species_group) === null || _a === void 0 ? void 0 : _a.color) {
                specieColor = specie.species_group.color;
            }
        }
        else {
            specieName = 'not set';
            specieColor = 'red';
            if (sighting.other) {
                if (this._turtles.includes((_b = sighting.other) === null || _b === void 0 ? void 0 : _b.trim())) {
                    specieName = (_c = sighting.other) === null || _c === void 0 ? void 0 : _c.trim();
                    specieColor = '#27AE60';
                }
            }
        }
        this._badge = new Badge2({ type: BadgeType2.info, color: specieColor });
        this._badge.appendTo(SpeciesDisplay._asParent(element));
        this._badge.getElement().html(`<b style="color: ${UtilColor.getContrastYIQ(specieColor !== null && specieColor !== void 0 ? specieColor : '#17a2b8')}">${specieName}</b>`);
        this._element = this._badge.getElement();
        if (specie) {
            /*
             * Left-click reveals the context menu with the two
             * external taxon links + the internal profiling page.
             */
            UtilSpeciesContextMenu.attach(this._element, {
                speciesId: specie.id,
                speciesName: specieName,
                ottId: specie.ottid,
                aphiaId: (_d = specie.aphiaid) !== null && _d !== void 0 ? _d : 0,
                onProfile
            });
        }
    }
    /**
     * Resolve a parent (bambooo component, jQuery or selector) to a jQuery
     * handle the badge can be appended to.
     * @param {ComponentType} element
     * @return {JQuery}
     * @protected
     */
    static _asParent(element) {
        const maybe = element;
        if (maybe && typeof maybe.getElement === 'function') {
            return maybe.getElement();
        }
        return jQuery(element);
    }
}
